export default {
  en: {    
    states: {
      new           : 'New',
      cancel        : 'Cancelled',
      accepted        : 'Accepted',
      onwaytopickup     : 'On way to pickup',
      nearpickup     : 'Near pickup',
      arrivedpickup     : 'Arrived at pickup',
      loading       : 'Loading',
      loaded        : 'Loaded',
      onwaytodelivery   : 'On way to delivery',
      onwaytodeliverypause  : 'Delivery paused',
      nearpickup     : 'Near delivery',
      arriveddelivery   : 'Arrived at delivery',
      unloading       : 'Unloading',
      unloaded        : 'Unloaded',
      delivered       : 'Geleverd',      
      finalised       : 'Ready for invoicing',
      invoicereceived : 'Received invoice',
      paid : 'Paid',
      pending: 'Pending',  
      pendingcmr:     'Upload proof of delivery',
      shipment_cancelled: 'Shipment cancelled',
      shipment_expired: 'Shipment expired',
      other_offer_accepted: 'Other offer accepted',
      update: {
        loaded: 'When where the goods loaded?',
        delivered: 'When where the goods delivered?',
        time: 'Time',
        savenext: 'Save and next'
      },
      rating: 'Rating',
      ratings: 'Ratings',
      received: 'Received',
      given: 'Given',
      filters: {
        acceptednodriver: 'Accepted without driver',
        accepteddriver: 'Accepted with driver',
        activeshipments: 'Active shipments',
        shouldinvoice: 'To be invoiced',
        invoiced: 'Already invoiced',
      }
    }        
  },
  nl: {    
    states: {
      new           : 'Nieuw',
      cancel        : 'Geannuleerd',
      accepted        : 'Aanvaard',
      onwaytopickup     : 'Onderweg naar ophaalpunt',
      nearpickup     : 'Vlakbij ophaalpunt',
      arrivedpickup     : 'Aangekomen bij ophaalpunt',
      loading       : 'Laden',
      loaded        : 'Geladen',
      onwaytodelivery   : 'Onderweg naar levering',
      onwaytodeliverypause  : 'Levering gepauzeerd',
      neardelivery   : 'Vlakbij leverpunt',
      arriveddelivery   : 'Aangekomen bij leverpunt',
      unloading       : 'Lossen',
      unloaded        : 'Gelost',
      delivered       : 'Geleverd',      
      pendingcmr      :     'Upload leverbewijs',
      finalised       : 'Klaar voor facturatie',
      invoicereceived : 'Factuur ontvangen',
      paid : 'Betaald',
      pending: 'In afwachting',
      shipment_cancelled: 'Zending geannuleerd',
      shipment_expired: 'Zending verlopen',
      other_offer_accepted: 'Ander bod aanvaard',
      update: {
        loaded: 'Wanneer werden de goederen geladen?',
        delivered: 'Wanneer werden de goederen geleverd?',
        time: 'Tijdstip',
        savenext: 'Opslaan en volgende'
      },    
      rating: 'Beoordeling',
      ratings: 'Beoordelingen',
      received: 'Ontvangen',
      given: 'Gegeven',
      filters: {
        acceptednodriver: 'Aanvaard zonder chauffeur',
        accepteddriver: 'Aanvaard met chauffeur',
        activeshipments: 'Actieve zendingen',
        shouldinvoice: 'Te factureren',
        invoiced: 'Reeds gefactureerd',
      }
    }            
  },
  fr: {    
    states: {
      new           : 'Nouveau',
      cancel        : 'Annulé',
      accepted        : 'Accepté',
      onwaytopickup     : 'En route pour le point de collecte',
      nearpickup     : 'Près du point du collecte',
      arrivedpickup     : 'Arrivé au point du collecte',
      loading       : 'Charger',
      loaded        : 'Chargé',
      onwaytodelivery   : 'En route pour livraison',
      onwaytodeliverypause  : 'Livraison pausé',
      neardelivery   : 'Près du point de livraison',
      arriveddelivery   : 'Arrivé au point de livraison',
      unloading       : 'Décharger',
      unloaded        : 'Déchargé',
      delivered       : 'Livré',      
      pendingcmr      :     'Téléchargez preuve de livraison',
      finalised       : 'Prêt pour facturation',
      invoicereceived : 'Facture reçu',
      paid : 'Payé',
      pending: 'En attente',
      shipment_cancelled: 'Envoi annulé',
      shipment_expired: 'Envoi expiré',
      other_offer_accepted: 'Autre offre accepté',
      update: {
        loaded: 'Quand les paquets ont-ils été chargés?',
        delivered: 'Quand les paquets ont-ils été déchargés?',
        time: 'Heure',
        savenext: 'Sauvegarder et suivant'
      },    
      rating: 'Évaluation',
      ratings: 'Évaluations',
      received: 'Reçu',
      given: 'Donné',
      filters: {
        acceptednodriver: 'Accepté sans chauffeur',
        accepteddriver: 'Accepté avec chauffeur',
        activeshipments: 'Envois actifs',
        shouldinvoice: 'À facturer',
        invoiced: 'Déjà facturé',
      }
    }            
  },
}
